export const ORGANIZATION_PERMISSIONS = {
  PLAN_MANAGE: 'PLAN_MANAGE',
  BILLING_VIEW: 'BILLING_VIEW',
  ORDER_CREATE: 'ORDER_CREATE',
  INVOICE_VIEW: 'INVOICE_VIEW',
  PAYMENT_MANAGE: 'PAYMENT_MANAGE',
};

export const BILLING_PERMISSIONS = Object.values(ORGANIZATION_PERMISSIONS);

const BILLING_ROLES = new Set([
  'organization administrator',
  'billing admin',
]);

export const hasOrganizationPermission = (membership, permission) => {
  if (!membership) return false;
  const role = String(membership.role || '').trim().toLowerCase();
  if (BILLING_ROLES.has(role)) return BILLING_PERMISSIONS.includes(permission);
  return Array.isArray(membership.permissions) && membership.permissions.includes(permission);
};

export const canManageOrganizationBilling = (membership) =>
  BILLING_PERMISSIONS.every((permission) => hasOrganizationPermission(membership, permission));
